<!-- Button group (desktop) -->
@if (items.length > 0) {
<div class="flex-row justify-center items-center w-full p-1 border-full border border-gray-500 bg-gray-50 rounded-full"
    [ngClass]="{'flex': alwaysShowPill,'hidden md:flex': !alwaysShowPill}">
    @for (item of items; track $index) {
    <button class="tab-pill flex-1 justify-center items-center"
        [ngClass]="{'active': item.key === activeElement?.key}"
        (click)="onClick(item)">
        @if (item.icon) {
        <i class="hidden md:block {{item.icon}}"></i>
        }
        @if (item.title) {
        <span class="md:text-[16px] text-sm">{{item.title}}</span>
        }
    </button>
    }
</div>
}

<!-- Toggle for modal (mobile)-->
<button
    class="md:hidden flex justify-between items-center w-full text-left px-4 py-3 border-[1px] rounded-full bg-white text-md text-black"
    [ngClass]="{'hidden': alwaysShowPill}"
    (click)="mobileViewModalCase()">
    {{ activeElement?.title || inputPlaceholder }}
    <i class="text-xl font-light text-secondary-900 icon-chevron-up"></i>
</button>